import { connect } from "react-redux";
import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import mapProps from "recompose/mapProps";
import omit from "lodash/omit";
import pick from "lodash/pick";
import forEach from "lodash/forEach";
import merge from "lodash/merge";
import {
  getActiveCanvasDrawer,
  setCompletedDrawerWithTimer,
} from "../CanvasDrawers/duck";
import withProduct from "../../hocs/withProduct";
import CreationForm from "./CreationForm";
import { withModel } from "../../data-providers/model";
import { fetchPrismicProduct } from "src/client/js/store/thunks/prismic/product";
import {
  getPrismicProductDrawer,
  getPrismicProduct,
  getPrismicProductByLocale,
} from "src/client/js/store/selectors/prismic/product";
import { setBookPreviewActivePage } from "../BookPreview/duck";
import { getGiftwrapComponents, replaceAddons } from "../CanvasDrawers/helpers";
import { findProductVariant } from "src/common/utils/product";

const enhance = compose(
  withProduct,
  connect(
    (state, props) => ({
      prismicProductLangs: getPrismicProduct(state, props.productId),
      activeDrawer: getActiveCanvasDrawer(state),
      prismicProduct: getPrismicProductByLocale(
        state,
        props.productId,
        props.productCustomisation.locale
      ),
      localisedDrawer: getPrismicProductDrawer(
        state,
        props.productId,
        props.productCustomisation.locale,
        props.drawer.sliceType
      ),
    }),
    (dispatch) => ({
      setBookPreviewActivePage: (page) =>
        dispatch(setBookPreviewActivePage(page)),
      setCompletedDrawer: (drawerId) => {
        setCompletedDrawerWithTimer(dispatch)(drawerId, 4000);
      },
    })
  ),
  connect(null, (dispatch, props) => ({
    fetchPrismicProduct: (sku, locale) =>
      dispatch(fetchPrismicProduct(sku, locale, props)),
  })),
  withHandlers({
    handleFormikSubmit: (props) => (values, nextDrawer) => {
      let newValues = omit(values, ["base"]);

      let drawer = props.drawer.sliceType;
      drawer =
        drawer === "interest"
          ? `${drawer}::${props.drawer.primary.type}`
          : drawer;

      const newProps = {
        ...props,
        queryParams: merge({}, props.queryParams, newValues),
        productCustomisation: merge({}, props.productCustomisation, newValues),
      };

      /* Check compatibility of giftwrap and swap sizes if necessary */
      const availableGiftwrapComponents = getGiftwrapComponents(newProps);
      const components = replaceAddons(newProps, availableGiftwrapComponents);

      newValues = { ...newValues, components };

      // Not sure what this does, I dont think it works as intended
      /* Check and remove format/cover/box if necessary */
      const newVariant = findProductVariant(
        newProps.product.variants,
        omit(newProps.productCustomisation, ["box", "cover", "components"]),
        props.model.countryModel
      );

      // This should always be true so Im not sure when the else if fired
      if (newVariant.options) {
        newValues = {
          ...newValues,
          ...pick(newVariant.options, ["box", "cover", "size"]),
        };
      } else {
        const toOmit = ["box", "cover", "format_identifier"];
        newValues = omit(newValues, toOmit);
        props.removeQueryParams(toOmit);
        props.removeProductCustomisation(toOmit);
      }

      // If the drawer we're submitting has allowed digi upsell to be used (controlled in our CMS)
      // then we want to add or update the product components
      if (props.drawer.primary.isUpsellEnabled) {
        forEach(values, (customisationValue, customisationKey) => {
          const upselledOption = props.productVariant.components.find(
            ({ type, id }) =>
              type === customisationKey && id.endsWith(customisationValue)
          );

          if (upselledOption) {
            newValues.components =
              newValues.components.length === 0
                ? [{ id: upselledOption.id }]
                : newValues.components.reduce((acc, { id }) => {
                    if (id.includes(customisationKey)) {
                      acc.push({ id: upselledOption.id });
                      return acc;
                    }

                    acc.push({ id });
                    return acc;
                  }, []);
          }
        });
      }

      // if it's avatars 3.0 we overwrite characters in the reducer
      // UPDATE_PRODUCT_CUSTOMISATION as that is where we also do it for
      // 'components' which are removed
      props.updateProductCustomisation(newValues);

      // if it's avatars 3.0 then overwrite nested object characters
      // to remove any params which need to be removed
      newValues.characters?.[0].customisations
        ? props.updateQueryParamsShallow(newValues)
        : props.updateQueryParams(newValues);

      props.setCompletedDrawer(drawer);

      if (props.drawer.primary.ctaPageNumber) {
        props.setBookPreviewActivePage(props.drawer.primary.ctaPageNumber);
      }

      if (props.activeDrawer !== nextDrawer) {
        props.onToggleDrawer(nextDrawer);
      }
    },
  }),
  withModel,
  mapProps((props) => ({
    activeDrawer: props.activeDrawer,
    completedDrawersMap: props.completedDrawersMap,
    productCustomisation: props.productCustomisation,
    queryParams: props.queryParams,
    onFormikSubmit: props.handleFormikSubmit,
    form: props.form,
    product: props.product,
    fetchPrismicProduct: props.fetchPrismicProduct,
    model: props.model,
    localisedDrawer: props.localisedDrawer,
    prismicProduct: props.prismicProduct,
    drawer: {
      sliceType: props.drawer.sliceType,
      ...props.drawer.primary,
      items: props.drawer.items,
    },
    onToggleDrawer: props.onToggleDrawer,
  }))
);

export default enhance(CreationForm);
